<template>
  <div
    v-if="$auth.user().id !== data.user.id"
    class="tw-mr-3 sm:tw-mr-5 tw-ml-10 md:tw-ml-32 tw-text-sm md:tw-text-base tw-self-end"
  >
    <div class="tw-flex tw-flex-col tw-items-end">
      <div class="tw-break-all tw-mt-2 tw-p-3 tw-bg-custom-lightgray3 tw-rounded-tl-xl tw-rounded-br-xl tw-rounded-bl-xl">
        {{ data.message }}
      </div>
      <span class="tw-block tw-px-4 tw-pt-2 tw-text-xxs tw-text-custom-gray tw-tracking-wide">{{ data.timeAgo }} ago</span>
    </div>
  </div>
  <div
    v-else
    class="tw-ml-3 sm:tw-ml-5 tw-mr-10 md:tw-mr-32 tw-text-sm md:tw-text-base tw-self-start "
  >
    <div class="tw-flex tw-flex-col tw-items-start">
      <div class="tw-break-all tw-mt-2 tw-p-3 tw-border tw-rounded-tr-xl tw-rounded-br-xl tw-rounded-bl-xl tw-border-custom-midgray2">
        {{ data.message }}
      </div>
      <span class="tw-block tw-px-4 tw-pt-2 tw-text-xxs tw-text-custom-gray tw-tracking-wide">{{ data.timeAgo }} ago</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
  },

  // mounted() {
  //   console.log('ChatMessage.data', this.data);
  // },
};
</script>
